import StarsOutlineIcon from '@/assets/stars-outline.svg?react'
import type { ListItemProps as BasicListItemProps } from '@/components/List/ListItem'
import BasicListItem from '@/components/List/ListItem'
import Toggle from '@/components/Toggle'
import useUserPreference, { UserPreference } from '@/utils/hooks/useUserPreference'
import { Button } from '@mantine/core'
import { modals } from '@mantine/modals'
import type { ReactNode } from 'react'
import styles from './FeaturePreviewItem.module.css'

export default function FeaturePreviewItem({
	children,
	title,
	feature: featureKey,
	preview,
	className,
	...props
}: BasicListItemProps & {
	feature: keyof Omit<UserPreference, 'theme'>
	preview?: ReactNode
}) {
	const [isEnabled, setIsEnabled] = useUserPreference(featureKey)

	const handlePreviewClick = () => {
		const modalId = modals.open({
			title,
			children: preview,
			classNames: {
				content: styles.previewModalContent,
				body: styles.previewModalBody,
			},
			onClose: () => {
				modals.close(modalId)
			},
			lockScroll: false,
			size: 'min(805px, calc(100vw - 32px))',
		})
	}

	return (
		<BasicListItem {...props} className={className}>
			<div>
				<span>{title}</span>
			</div>

			<div className={styles.actions}>
				{preview && (
					<Button size="sm" variant="outline" onClick={handlePreviewClick}>
						<StarsOutlineIcon className={styles.icon} />
					</Button>
				)}
				<Toggle checked={isEnabled} onChange={() => setIsEnabled((prev) => !prev)} />
			</div>
		</BasicListItem>
	)
}
